import axios from 'axios';

// APIベースURLの設定
export const API_BASE_URL: string = (() => {
    const hostname = window.location.hostname;

    if (hostname === 'localhost') {
        return 'http://localhost:8080'; // ローカル環境
    } else if (hostname === 'alb-web-239912845.ap-northeast-1.elb.amazonaws.com') {
        return 'http://alb-web-239912845.ap-northeast-1.elb.amazonaws.com'; // AWSのロードバランサー環境
    } else if (hostname === 'trial.starpier.jp') {
        return 'https://trial.starpier.jp';
    } else {
        return 'http://localhost:8080'; // デフォルト
    }
})();

export const api = {
    postContact: async (contactData: any) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/api/survey/contact`, contactData);
            return response.data;
        } catch (error) {
            throw new Error(`Failed to post contact data: ${error}`);
        }
    },

    postMail: async (contactData: any, results: string) => {
        try {
            await axios.post(
                `https://qmd3nbzli1.execute-api.ap-northeast-1.amazonaws.com/for-starpier/send`,
                contactData
            );
        } catch (error) {
            throw new Error(`Failed to send mail: ${error}`);
        }
    },

    getQuestions: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/api/survey/questions`);
            return response.data;
        } catch (error) {
            throw new Error(`Failed to get questions: ${error}`);
        }
    },

    postResults: async (userId: string) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/api/survey/results`, { userId });
            return response.data;
        } catch (error) {
            throw new Error(`Failed to post results: ${error}`);
        }
    },

    postResponses: async (formattedAnswers: any) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/api/survey/responses`, formattedAnswers);
            return response.data;
        } catch (error) {
            throw new Error(`Failed to post responses: ${error}`);
        }
    }
};
